import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Tokenomics from "@/components/Tokenomics";
import HowToBuy from "@/components/HowToBuy";
import Roadmap from "@/components/Roadmap";
import Footer from "@/components/Footer";

const HomePage = () => {
  return (
    <main className="min-h-screen bg-[#05000A]">
      <Header />
      <Hero />
      <Marquee />
      <Tokenomics />
      <HowToBuy />
      <Roadmap />
      <Footer />
    </main>
  );
};

export default HomePage;
